import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  selectStoreWorkingHours,
  selectToken,
} from "../../../../../../redux-store/selectors";
import { updateStoreWorkingHoursAction } from "../../../../constants/actions";
import {
  updateStoreWorkingHoursSuccess,
  updateStoreWorkingHoursFailure,
  updateStoreWorkingHours,
} from "../../../actions/Manager";
import { updateStoreWorkingHours as updateStoreWorkingHoursReq } from "../../../../axios/Manager";
import { notify } from "react-notify-toast";
import { union } from "ts-action";
import { IRootReducerState } from "../../../../../../redux-store/rootReducer";

const actionTypes = union({ updateStoreWorkingHours });

function* updateStoreWorkingHoursSaga(action: typeof actionTypes) {
  try {
    if (!action.payload.reason) {
      yield put(updateStoreWorkingHoursFailure(new Error("Reason is required")));
      return;
    }
    const token = yield select(selectToken);
    const { data, reason, schedule_id } = action.payload;
    const prevStoreHours: IRootReducerState["getStoreWorkingHoursReducer"] =
      yield select(selectStoreWorkingHours);

    yield call(updateStoreWorkingHoursReq, token, {
      data,
      schedule_id,
    });
    yield put(
      updateStoreWorkingHoursSuccess({
        ...action.payload.data,
        reason,
        __prevStoreHours: prevStoreHours,
      })
    );

    notify.show("Store working hours updated successfully", "success");
  } catch (error) {
    yield put(updateStoreWorkingHoursFailure(error as Error));
    notify.show("Failed to update store working hours!", "error");
  }
}

export function* watchUpdateStoreWorkingHoursSaga() {
  yield takeLatest(
    updateStoreWorkingHoursAction.requested,
    updateStoreWorkingHoursSaga
  );
}
